import { Action, ComplaintTypeState } from './types'

// setEventOccurrence
export const setEventOccurrence = (
    { dateOfOccurrence = null, location = '' } = {} as ComplaintTypeState
) => ({
    type: 'SET_EVENT_OCCURRENCE',
    payload: {
        dateOfOccurrence,
        location,
    },
})

// setComplaintType
export const setComplaintType = (
    {
        complaintType = '',
        estheticExplanation = '',
        otherExplanation = '',
        surfaceDefectExplanation = '',
        attachmentIds = []
    } = {} as ComplaintTypeState
) => ({
    type: 'SET_COMPLAINT_TYPE',
    payload: {
        complaintType,
        estheticExplanation,
        otherExplanation,
        surfaceDefectExplanation,
        attachmentIds
    },
})

export const resetComplaintType = () => {
    return {
        type: 'RESET_COMPLAINT_TYPE',
        payload: {
            complaintType: '',
            estheticExplanation: '',
            otherExplanation: '',
            surfaceDefectExplanation: '',
        },
    }
}

const complaintTypeReducer: React.Reducer<ComplaintTypeState, Action> = (
    state: ComplaintTypeState,
    action: Action
) => {
    switch (action.type) {
        case 'SET_EVENT_OCCURRENCE':
            return {
                ...state,
                dateOfOccurrence: action.payload.dateOfOccurrence,
                location: action.payload.location,
            }

        case 'SET_COMPLAINT_TYPE':
            return {
                ...state,
                complaintType: action.payload.complaintType,
                estheticExplanation: action.payload.estheticExplanation,
                otherExplanation: action.payload.otherExplanation,
                surfaceDefectExplanation: action.payload.surfaceDefectExplanation,
                attachmentIds: action.payload.attachmentIds
            }

        case 'RESET_COMPLAINT_TYPE':
            return {
                ...state,
                ...action.payload,
            }

        default:
            return state
    }
}

export default complaintTypeReducer
